import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const DifficultyName = ({
  difficultyList,
  handleDifficulty,
  difficultyName,
  difficultyId,
}) => {
  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Difficulty Name</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={difficultyId + "#" + difficultyName}
          label="Difficulty Name"
          onChange={handleDifficulty}
        >
          <MenuItem value="">None</MenuItem>
          {difficultyList?.map((el) => (
            <MenuItem
              key={el?.difficultyId}
              value={`${el.difficultyId}#${el.difficultyName}`}
            >
              {el.difficultyName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default DifficultyName;
